import { useEffect, useState } from 'react';
import AsoHeader from '../../../components/Aso/Header';
import ReaproveitamentoAsoPagamentoTrabalhador from '../../../components/Reaproveitamentos/AsoPagamentoTrabalhador';
import api from "../../../services/api";
import { useNavigate, useParams } from "react-router-dom";

export function AsoPagamentoTrabalhador() {
  const [imageSrc, setImageSrc] = useState(null);
  const { idConsulta, dbName } = useParams();

  const handleSearchLogo = async () => {
    try {
        const response = await api.get(`get-logo-image/${dbName}`);
        const base64Image = response.data.data;
        const imageObjectURL: any = `data:image/png;base64,${base64Image}`;
        setImageSrc(imageObjectURL);

    } catch (error) {
        console.log(error);
    }
  }

  useEffect(() => {
    handleSearchLogo();
  }, [handleSearchLogo]);


  return (
    <div>
      <AsoHeader logo={imageSrc}  />
      <ReaproveitamentoAsoPagamentoTrabalhador />
    </div>
  );
}
